import { createFileRoute, stripSearchParams, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

import { ReviewDataPage } from '@/components/Business/ReviewDataPage'
import {
  EMPTY_REVIEW_DATA_SEARCH,
  type ReviewDataSearch,
  reviewDataSearchSchema,
  withoutReviewDataDefaults,
} from '@/components/Business/reviewDataSearch'

/** Wiring only. The schema lives beside the page in `reviewDataSearch.ts`. */
export const Route = createFileRoute('/_app/business/review-data')({
  validateSearch: reviewDataSearchSchema,
  search: { middlewares: [stripSearchParams(EMPTY_REVIEW_DATA_SEARCH)] },
  component: ReviewDataRoute,
})

function ReviewDataRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  const onSearchChange = useCallback(
    (next: Partial<ReviewDataSearch>) =>
      void navigate({
        search: (current) => withoutReviewDataDefaults({ ...current, ...next }),
        replace: true,
        resetScroll: false,
      }),
    [navigate],
  )
  return <ReviewDataPage search={search} onSearchChange={onSearchChange} />
}
